import * as a from "react";
const t = (l) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M22.436 9.786l-1.26-.45a1.34 1.34 0 01-.81-.77 1.379 1.379 0 010-1.11l.65-1.22a2.37 2.37 0 00-3.16-3.16l-1.22.58a1.43 1.43 0 01-1.11 0 1.399 1.399 0 01-.77-.81l-.45-1.27a2.38 2.38 0 00-4.48 0l-.5 1.3a1.4 1.4 0 01-1.325.922c-.19 0-.379-.038-.555-.112l-1.22-.61a2.37 2.37 0 00-3.16 3.16l.58 1.22a1.38 1.38 0 010 1.11 1.34 1.34 0 01-.81.77l-1.26.45a2.38 2.38 0 000 4.48l1.26.45a1.34 1.34 0 01.81.77 1.38 1.38 0 010 1.11l-.58 1.22a2.37 2.37 0 003.16 3.21l1.22-.57a1.34 1.34 0 011.11 0 1.37 1.37 0 01.77.81l.45 1.26a2.38 2.38 0 004.48 0l.45-1.26a1.37 1.37 0 01.77-.81 1.34 1.34 0 011.11 0l1.22.57a2.37 2.37 0 003.21-3.21l-.58-1.22a1.38 1.38 0 010-1.11 1.34 1.34 0 01.81-.77l1.26-.45a2.38 2.38 0 000-4.48h-.07zm-10.42 7.03a5 5 0 01-4.44-2.95 4.8 4.8 0 012.6-6.28 4.87 4.87 0 016.28 2.6 4.799 4.799 0 01-2.6 6.28 4.531 4.531 0 01-1.84.35z",
      fill: "#2d6ded"
    }
  )
), e = t;
export {
  e as default
};
